/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { jsx, css } from '@emotion/react'
import { Trans, Translation } from 'react-i18next'
import { Separator } from './layout/Separator'
import { Row, Col, Container } from 'react-bootstrap'
import CommonTable from './CommonTable'
import { get, union, size, map, head, includes } from 'lodash'
import CurrencyValue from './CurrencyValue'
import { default_theme as theme } from '../emotion/theme'
import Card from './layout/Card'
import NestedWrappingBusyMask from './NestedWrappingBusyMask'
import { molliePaymentList } from '../actions/mollie_payment'
import { BlueButton } from './layout/BlueButton'
import { WhiteLinkButton } from './layout/WhiteLinkButton'
import { OrangeLinkButton } from './layout/OrangeLinkButton'
import { ButtonBar } from './layout/ButtonBar'
import { upgradePathList } from '../actions/upgrade_path'
import { productListForUpgradePath } from '../actions/product'
import { InlineIcon } from './layout/InlineIcon'
import { customerSubscriptionUpgradePathList} from '../actions/customer_subscription'

export const UpgradePathNotificationMinimumOutgoingFaxCostEuros1Sept2021 = ({upgrade_path, display_style, onHideNotification, onDidRender}) => {

    const dispatch = useDispatch()
    const history = useHistory()
    const is_loading = useSelector(() => upgradePathList.isLoading())
    const is_saving = useSelector(() => upgradePathList.getIsSavingObject())
    const fax_sending_products = useSelector(() => productListForUpgradePath.getVisibleObjects())
    const is_loading_products = useSelector(() => productListForUpgradePath.isLoading())
    const fax_sending_sub = useSelector(() => head(customerSubscriptionUpgradePathList.getVisibleObjects()))
    
    useEffect(() => {
        dispatch(productListForUpgradePath.updateListFilter({can_send_faxes: true}))
        dispatch(productListForUpgradePath.updateListOrdering("annual_subscription_price_excluding_vat_euros"))
        dispatch(productListForUpgradePath.fetchListIfNeeded())

        dispatch(customerSubscriptionUpgradePathList.updateListFilter({can_send_faxes: true}))
        dispatch(customerSubscriptionUpgradePathList.fetchListIfNeeded())
    }, [])
    const product_headers = {
        name: { name: <Trans>FAX SUBSCRIPTIONS</Trans>,
                renderValue: function(item) {

                    return (
                    <>
                      <div css={product_header_style}>{item.is_customers_subscription ? <Trans>No paid subscription</Trans> : item.name}</div>

                      { item.is_customers_subscription &&
                        <div>
                          <div css={your_current_situation_style}>
                            <Trans>Your current situation</Trans>
                          </div>
                        </div>
                      }
                      
                      { !item.is_customers_subscription && !item.can_receive_faxes && !item.can_receive_voice && <Trans>Only fax sending</Trans> }
                      { !item.is_customers_subscription && item.can_receive_faxes && <Trans>Incl. fax number</Trans> }
                    </>
                    )
                }
              },
        per_year: { name: <Trans>per year</Trans>,
                    renderValue: (item) => item.annual_subscription_price_excluding_vat_euros > 0 ? <CurrencyValue value={item.annual_subscription_price_excluding_vat_euros} /> : "-"
                  },
        min_per_fax: {name: <Trans>min. per fax</Trans>,
                      renderValue: (item) => item.minimum_outgoing_fax_cost_excluding_vat_euros > 0 ? <CurrencyValue value={item.minimum_outgoing_fax_cost_excluding_vat_euros} /> : "-"
                     },
                
        min_per_path: { name: "per page",
                        renderValue: (item) => <CurrencyValue value={item.minimum_outgoing_fax_cost_per_page_excluding_vat_euros} />
                       },
    }
    
    const onGetASubscription = () => {
        history.push("/subscription/fax")
    }

    const renderProducts = () => {

        const fake_product_representing_fax_sending_subscription = {name: 'No paid subscription',
                                                                    is_customers_subscription: true,
                                                                    minimum_outgoing_fax_cost_excluding_vat_euros: get(fax_sending_sub, 'product_minimum_outgoing_fax_cost_excluding_vat_euros'),
                                                                    minimum_outgoing_fax_cost_per_page_excluding_vat_euros: get(fax_sending_sub, 'product_minimum_outgoing_fax_cost_per_page_excluding_vat_euros'), 
                                                                    can_receive_faxes: get(fax_sending_sub, 'product_can_receive_faxes'),
                                                                    can_receive_voice: get(fax_sending_sub, 'product_can_receive_voice')}
        
        const items = union([fake_product_representing_fax_sending_subscription],
                            fax_sending_products)
        
        return (
            <CommonTable is_loading={ is_loading }
                         pagination_mode="off"
                         headers={ product_headers }
                         items={items}
                         item_list={productListForUpgradePath}
            />
        )
    }
    
    const render_for_send_a_fax_dashboard = (upgrade_path) => {
        return (
            <div css={container_style}>

              <Row>
                <Col md={6}>
                  
                  <h1 css={header_style}>
                    <Trans i18nKey="upgrade_path_minimum_outgoing_fax_cost_euros_1Sept2021__heading">
                      Please note: fax sending costs have changed
                    </Trans>
                  </h1>

                  <Separator variant="h20" />
                  
                  <div>
                    <Trans i18nKey="upgrade_path_minimum_outgoing_fax_cost_euros_1Sept2021__para1">
                      From 9 September 2021 a new minimum charge of €2 per sent fax applies.
                    </Trans>
                    <Separator variant="h20" />
                    <Trans i18nKey="upgrade_path_minimum_outgoing_fax_cost_euros_1Sept2021__para2">
                      You can use up credits purchased before 9 September 2021 under the old conditions (ie. without the €2 minimum charge) until 31 March 2022. As soon as you purchase new credits the minimum charge will apply.
                    </Trans>
                    <Separator variant="h20" />
                    <Trans i18nKey="upgrade_path_minimum_outgoing_fax_cost_euros_1Sept2021__para3">
                      For customers with a Fax Out or Fax Complete subscription the minimum charge does not apply.
                      On the right, see an overview of our subscription options and fax sending costs.
                    </Trans>
                  </div>

                  <Separator variant="h20" />

                  <ButtonBar>
                    <BlueButton onClick={onGetASubscription}>
                      <Trans i18nKey="upgrade_path_minimum_outgoing_fax_cost_euros_1Sept2021__get_a_sub_button">
                        Get a subscription
                      </Trans>
                    </BlueButton>

                    <WhiteLinkButton onClick={() => onHideNotification(upgrade_path)}>
                      <NestedWrappingBusyMask is_loading={is_saving}>
                        <Trans i18nKey="upgrade_path__dont_show">
                          Don't show this again
                        </Trans>
                      </NestedWrappingBusyMask>
                    </WhiteLinkButton>
                  </ButtonBar>

                </Col>
                <Col>
                  {renderProducts()}
                </Col>
              </Row>
            </div>
        )
    }

    const render_for_topup = (upgrade_path) => {
        return (
            <Row>
              <Col md={6}>
                <div css={container_style}>

                  <div css={inline_header_row_style}>
                    <span css={inline_header_style}>
                      <Trans i18nKey="upgrade_path_minimum_outgoing_fax_cost_euros_1Sept2021__topup__heading1">
                        Please note:
                      </Trans>
                    </span>
                    &nbsp;
                    <Trans i18nKey="upgrade_path_minimum_outgoing_fax_cost_euros_1Sept2021__topup__heading2">
                      the recently introduced minimum charge of €2 per fax will come into effect for you after this credit purchase.
                    </Trans>
                    
                  </div>

                  <Separator variant="h10" />
                  
                  <div>
                    <Trans i18nKey="upgrade_path_minimum_outgoing_fax_cost_euros_1Sept2021__topup__para1">
                      With a Fax-Out subscription (or other paid subscription) you avoid this minimum charge and reduce your cost per page.
                    </Trans>
                    <Separator variant="h10" />
                  </div>

                  <ButtonBar>
                    <OrangeLinkButton onClick={onGetASubscription}>
                      <Trans i18nKey="upgrade_path_minimum_outgoing_fax_cost_euros_1Sept2021__topup__see_subs_button">
                        See the subscriptions
                      </Trans>
                      &nbsp;
                      <InlineIcon icon_name="chevron-right" variant="secondary_orange" />
                    </OrangeLinkButton>

                  </ButtonBar>
                  
                </div>
              </Col>
            </Row>
        )
    }

    if ( display_style === 'topup' ) {
        onDidRender()
        return render_for_topup(upgrade_path)
    } else if ( display_style === 'send_a_fax_dashboard' ) {
        onDidRender()
        return render_for_send_a_fax_dashboard(upgrade_path)
    } else {
        return null
    }
}

const container_style = css`
background-color: ${theme.colors.dark_green};
width: 100%;
margin-bottom: 30px;
padding: 20px 20px 18px;
border-radius: 10px;
color: ${theme.colors.white};
`

const header_style = css`
font-size: 20px;
font-weight: bold;
`

const inline_header_row_style = css`
`

const inline_header_style = css`
font-weight: bold;
`

const product_header_style = css`
font-weight: bold;
`

const your_current_situation_style = css`
background-color: ${theme.colors.primary_orange};
border-radius: 4px;
color: ${theme.colors.white};
padding-left: 3px;
padding-right: 3px;
width: fit-content;
`
